import {Inject, Injectable} from '@angular/core';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {CookieService} from 'ngx-cookie-service';
import {TranslateService} from '@ngx-translate/core';
import {ToastrService} from 'ngx-toastr';
import {catchError} from 'rxjs/operators';
import {NEVER, of} from 'rxjs';
import {OidcSecurityService} from 'angular-auth-oidc-client';
import {Router} from '@angular/router';

@Injectable()
export class ApiService {
  developingMode = false;
  api = 'https://app.alobodo.com';

// Services
  constructor(private http: HttpClient, private cookieService: CookieService,
              public translate: TranslateService,
              private router: Router,
              public oidcSecurityService: OidcSecurityService,
              public toastr: ToastrService,) {
    if (this.developingMode) {
      this.api = '';
    }
  }

  currentDirection = 'rtl';

  onSetLanguage(language, langId) {
    this.cookieService.set('dir', language);
    this.cookieService.set('lang', langId);
    // localStorage.setItem('dir', language);
  }

  showMessage(message, id) {
    if (id === 1) {
      this.translate.get(message).subscribe((res) => {
        this.toastr.success(res);
      });
    } else if (id === 0) {
      this.translate.get(message).subscribe((response) => {
        this.toastr.error(response);
      });
    } else {
      this.translate.get('Message.ServerError').subscribe((response) => {
        this.toastr.error(response);
      });
    }

  }

  apiCall(method, route, body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
// console.log(this.oidcSecurityService.getToken())
    if (method === 'post') {
      return this.http.post(this.api + route, body, {headers}).pipe(
        catchError(error => {
          // window.location.href = ' ';
          this.router.navigate(['']);
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'get') {
      return this.http.get(this.api + route, {headers}).pipe(
        catchError(error => {
          if (error.status === 401) {
            // window.location.href = ' ';
            this.router.navigate(['']);
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'delete') {
      return this.http.delete(this.api + route, {headers}).pipe(
        catchError(error => {
          if (error.status === 401) {
            this.router.navigate(['']);
            // window.location.href = ' ';
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    } else if (method === 'put') {
      return this.http.put(this.api + route, body, {headers}).pipe(
        catchError(error => {
          if (error.status === 401) {
            this.router.navigate(['']);
            // window.location.href = ' ';
            return NEVER;      // <-- never emit after the redirect
          }
          // this.showMessage(' ', null);
          return of([]);
        })
      );
    }
  }

  registerConfirm() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      lang: this.cookieService.get('lang'),
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/Account/RegisterConfirm/', {headers});
  }

  GetPrivacy() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/setting/GetPrivacy/', {headers});

  }

  UpdatePrivacy(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.put(this.api + '/api/Setting/UpdatePrivacy/', body, {headers});

  }

  GetTerms() {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/setting/GetTerms/', {headers});

  }

  UpdateTerms(body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.put(this.api + '/api/setting/UpdateTerms/', body, {headers});

  }

  GetNotTranslatedContents(languageId, data, number) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.get(this.api + '/api/setting/GetNotTranslatedContents/'
      + languageId + '/' + data + '/' + Number(this.cookieService.get('lang')) + '/' + number, {headers});
  }

  AddNewTranslate(languageId, body) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/json;charset=UTF-8',
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.post(this.api + '/api/setting/AddNewTranslate/' + languageId, body, {headers});
  }

  AddFile(body) {
    const headers = new HttpHeaders({
      Authorization: 'Bearer ' + this.oidcSecurityService.getToken()
    });
    return this.http.post(this.api + '/api/Gallery/AddFile/', body, {headers});
  }

  // getSkillImage(image) {
  //   const headers = new HttpHeaders({
  //     'Content-Type': 'application/json;charset=UTF-8',
  //   });
  //   return this.http.get('https://test.alobodo.com' + '/api/image/GetImage/' + image, {
  //     headers,
  //   });
  // }

}
